import React from 'react';
import { BreadcrumbsItem } from '@cp/ds/src/components/breadcrumbs';
import { useCurrentCity } from '@cp/entities/location';
import { useClientWebResolver, useClientWebRouteParams } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { ROUTES_DEFAULT_CITY_ALIAS } from '@common/const/routes/defaultCity';

export const useBaseBreadcrumbs = (): BreadcrumbsItem[] => {
  const { currentCity } = useCurrentCity({ allowEmptyValue: true });
  const resolver = useClientWebResolver();

  return React.useMemo(() => {
    const cityAlias = currentCity?.alias ?? ROUTES_DEFAULT_CITY_ALIAS;
    const breadcrumbs: BreadcrumbsItem[] = [
      {
        path: String(
          resolver.resolve({
            page: ClientWebPage.Home,
            cityAlias,
          }),
        ),
        label: 'Главная',
      },
    ];

    return breadcrumbs;
  }, [currentCity, resolver]);
};
